"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoopTimeline = void 0;
var NoopTimeline = /** @class */ (function () {
    function NoopTimeline() {
    }
    NoopTimeline.prototype.log = function () { };
    return NoopTimeline;
}());
exports.NoopTimeline = NoopTimeline;
function aNoopTimeline() {
    return new NoopTimeline();
}
exports.default = aNoopTimeline;
//# sourceMappingURL=noop-timeline.js.map